import { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { Dialog, DialogActions, DialogContent, useMediaQuery } from '@mui/material';
import type { DialogActionsProps, DialogContentProps, DialogProps } from '@mui/material';

export type ResponsiveDialogProps = DialogProps & {
  mobileFullScreen?: boolean;
};

const ResponsiveDialog = forwardRef<HTMLDivElement, ResponsiveDialogProps>(function ResponsiveDialog(
  { fullWidth = true, maxWidth = 'sm', mobileFullScreen = true, fullScreen, ...dialogProps },
  ref
) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const resolvedFullScreen = fullScreen ?? (mobileFullScreen && isMobile);

  return (
    <Dialog ref={ref} fullWidth={fullWidth} maxWidth={maxWidth} fullScreen={resolvedFullScreen} {...dialogProps} />
  );
});

export const ResponsiveDialogContent = forwardRef<HTMLDivElement, DialogContentProps>(function ResponsiveDialogContent(
  { sx, ...dialogContentProps },
  ref
) {
  return (
    <DialogContent
      ref={ref}
      sx={[
        { display: 'flex', flexDirection: 'column', gap: 2, width: '100%' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...dialogContentProps}
    />
  );
});

export const ResponsiveDialogActions = forwardRef<HTMLDivElement, DialogActionsProps>(function ResponsiveDialogActions(
  { sx, ...dialogActionsProps },
  ref
) {
  return (
    <DialogActions
      ref={ref}
      sx={[
        {
          px: { xs: 2, sm: 3 },
          pb: { xs: 2, sm: 3 },
          flexWrap: 'wrap',
          gap: 1,
          '& > :not(style) ~ :not(style)': { ml: 0 },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...dialogActionsProps}
    />
  );
});

export default ResponsiveDialog;
